import { addJob } from '../State/jobs'

export default () => (dispatch, getState) => {

  const { activeTab } = getState().screens.Planner.ProjectCellModal

  dispatch(addJob(activeTab))

}
